export class InMemoryLocalStorage implements Storage {
  private readonly storage: object

  constructor(storage: object) {
    this.storage = storage || {}
  }

  getItem = (key: string): string | null => {
    if (key in this.storage) {
      return this.storage[key]
    } else {
      return null
    }
  }
}

export class BrowserStorageFactory {
  build = (): Storage => {
    try {
      const testString = `__storage_test__`
      window.localStorage.setItem(testString, testString)
      window.localStorage.removeItem(testString)

      return window.localStorage
    } catch (error) {
      return new InMemoryLocalStorage({})
    }
  }
}
